import News from "../components/news";
import BackgroundDisplay from "../components/background-display";
const AllNews = () => {
    return ( 
        <div>
            <BackgroundDisplay title="News & Updates"/>
            <News/>
        </div>
     );
}
 
export default AllNews;